import { Routes } from '@angular/router';
import { PaymentComponent } from './pages/payment/payment.component';
import { ShortLinkLoaderComponent } from './pages/short-link-loader/short-link-loader.component';
import { ServiceUnavailableComponent } from './pages/service-unavailable/service-unavailable.component';

export const routes: Routes = [
  {
    path: 'payment',
    loadComponent: () => Promise.resolve(PaymentComponent),
  },
  {
    path: 'service-unavailable',
    loadComponent: () => Promise.resolve(ServiceUnavailableComponent),
  },
  // default route: redirect to /payment
  { path: '', redirectTo: 'payment', pathMatch: 'full' },
  // Wildcard catch-all: delegate short-link resolution to ShortLinkLoaderComponent
  {
    path: '**',
    loadComponent: () => Promise.resolve(ShortLinkLoaderComponent),
  },
];
